import { User } from 'src/types'

export enum UsersActionTypes {
  GET_USERS = '@users/GET_USERS',
  GET_USERS_FAILURE = '@users/GET_USERS_FAILURE',
  GET_USERS_SUCCESS = '@users/GET_USERS_SUCCESS'
}

export interface ResponseDataUsers {
  users: User[]
}

export interface UsersState {
  error: boolean
  list: User[]
  loading: boolean
}
